// First, import environment and create the logger
import { environment } from './environments/environment'

// Create a simplified logger function that respects environment settings
// Execute this immediately as an IIFE to override console methods as early as possible
;(function setupEarlyLogging() {
  // Save original console methods
  const originalConsole = {
    log: console.log,
    error: console.error,
    warn: console.warn,
    info: console.info,
    debug: console.debug,
  }

  // Override console methods based on environment
  // TEMPORARY: FORCE ALL LOGS TO SHOW FOR DEBUGGING
  console.log = function (...args) {
    originalConsole.log.apply(console, args) // ALWAYS SHOW
  }

  console.warn = function (...args) {
    originalConsole.warn.apply(console, args) // ALWAYS SHOW
  }

  console.info = function (...args) {
    originalConsole.info.apply(console, args) // ALWAYS SHOW
  }

  console.debug = function (...args) {
    originalConsole.debug.apply(console, args) // ALWAYS SHOW
  }

  console.error = function (...args) {
    originalConsole.error.apply(console, args) // ALWAYS SHOW
  }

  return originalConsole
})()

// Now import all other dependencies
import { enableProdMode, importProvidersFrom } from '@angular/core'
import { AppComponent } from './app/app.component'
import { provideHttpClient, withInterceptors } from '@angular/common/http'
import { routes } from './app/routes'
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser'
import { AuthService } from './app/services/auth.service'
import { IonicModule, IonicRouteStrategy, isPlatform } from '@ionic/angular'
import {
  RouteReuseStrategy,
  provideRouter,
  withComponentInputBinding,
} from '@angular/router'
import { authInterceptor } from './app/interceptors/auth.interceptor'
import { errorInterceptor } from './app/interceptors/error.interceptor'
import { httpLoggerInterceptor } from './app/interceptors/http-logger.interceptor'
import { retryInterceptor } from './app/interceptors/retry.interceptor'
import { dnsFallbackInterceptor } from './app/interceptors/dns-fallback.interceptor'
import { provideCharts, withDefaultRegisterables } from 'ng2-charts'
import { provideNgxStripe } from 'ngx-stripe'
import { LoggerService } from './app/services/logger.service'

if (environment.production) {
  enableProdMode()
}

// Stripe initialization logging is controlled by environment
if (environment.logLevel === 'debug')
  console.log('Initializing Stripe with public key:', environment.stripePubKey)

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      BrowserModule,
      IonicModule.forRoot({
        animated: !isPlatform('desktop'),
        innerHTMLTemplatesEnabled: true,
      }),
    ),
    provideRouter(routes, withComponentInputBinding()),
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideHttpClient(
      withInterceptors([
        httpLoggerInterceptor,
        authInterceptor,
        dnsFallbackInterceptor, // Must run before retry interceptor
        retryInterceptor,
        errorInterceptor,
      ]),
    ),
    provideCharts(withDefaultRegisterables()),
    AuthService,
    LoggerService,
    provideNgxStripe(environment.stripePubKey),
  ],
}).catch((err) => console.error('Application bootstrap error:', err))
